import { io } from 'socket.io-client';

// Derive socket URL from the same host as the REST API (strip the /api path)
const SOCKET_URL = new URL(process.env.REACT_APP_API_URL || 'http://localhost:5000/api').origin;

let socket = null;

/**
 * Returns the shared socket instance, creating it on first call.
 * If the socket exists but has been disconnected, reconnects it.
 * Reads the JWT from localStorage so it always uses the current session's token.
 */
export const getSocket = () => {
  if (socket) {
    // Socket exists but may have been disconnected — reconnect with fresh token
    if (!socket.connected) {
      socket.auth = { token: localStorage.getItem('token') };
      socket.connect();
    }
    return socket;
  }

  const token = localStorage.getItem('token');

  socket = io(SOCKET_URL, {
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionAttempts: 10,
  });

  socket.on('connect_error', (err) => {
    console.error('[Socket] auth/connect failed:', err.message);
  });

  return socket;
};

/**
 * Disconnect and clear the singleton.
 * Call this on logout so the next login gets a fresh connection with the new token.
 */
export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
